<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Nuevo {{ textoTopePrecio }}</v-toolbar-title>
      </v-toolbar>
      <v-form
        class="dialog-topes"
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
      >
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="profsBuscar"
                item-text="nombreProfesional"
                item-value="idProfesional"
                menu-props="auto"
                label="Profesional *"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                dense
                no-data-text="No hay Profesionales configurados"
              ></v-select>
            </v-col>
            <v-col class="os-col" cols="12" md="6" sm="6">
              <v-select
                v-model="os"
                :items="itemsWithSelectAll"
                item-text="nombre"
                item-value="idObraSocial"
                label="Obra Social *"
                multiple
                chips
                dense
                prepend-icon="mdi-account"
                @change="onChange"
              ></v-select>
            </v-col>

            <v-col v-if="!esPrecio" cols="12" sm="4" md="4">
              <v-text-field
                v-model="fechaDesde"
                :value="fechaDesde"
                label="Fecha Vigencia Desde *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col v-if="!esPrecio" cols="12" sm="4" md="4">
              <v-text-field
                v-model="fechaHasta"
                :value="fechaHasta"
                label="Fecha Vigencia Hasta *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col v-if="!esPrecio" cols="12" sm="4" md="4">
              <v-text-field
                v-model="cantMaxTurnos"
                prepend-icon="mdi-calendar"
                :rules="totalRules"
                label="Tope Diario de Turnos *"
                @keypress="onlyNumber"
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col v-if="esPrecio" cols="12" sm="4" md="4" class="tipo-turno">
              <v-select
                :items="tiposTurnoItems"
                item-text="nombreTipoTurno"
                item-value="idTipoTurno"
                menu-props="auto"
                label="Tipo de Turno"
                hide-details
                prepend-icon="mdi-tag"
                v-model="idTipoTurno"
                dense
                no-data-text="No hay Tipos de Turno configurados"
              ></v-select>
            </v-col>
            <v-col v-if="esPrecio" cols="12" sm="4" md="4">
              <v-text-field
                v-model="precioConsulta"
                prepend-icon="mdi-currency-usd"
                :rules="totalRules"
                label="Precio Consulta *"
                @blur="toFixed"
                @keypress="onlyNumberAndComma"
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col v-if="esPrecio" cols="12" sm="4" md="8" class="mt-2 flags">
              <v-checkbox
                v-model="esSena"
                label="Es Seña"
                color="primary"
                dense
              ></v-checkbox>
              <v-text-field
                v-if="esSena"
                v-model="precioFinal"
                prepend-icon="mdi-cash-multiple"
                label="Precio Final (total de la consulta)"
                hint="Precio total de la consulta. El 'Precio Consulta' es lo que se cobrará como seña."
                persistent-hint
                @blur="toFixedFinal"
                @keypress="onlyNumberAndComma"
                maxlength="10"
                dense
                class="ml-2"
                style="max-width: 220px"
              ></v-text-field>
              <v-checkbox
                v-model="muestraEnWeb"
                label="Muestra precio en Web"
                color="primary"
                dense
              ></v-checkbox>
              <v-select
                class="mt-4"
                :items="requierePagoItems"
                v-model="obligaPago"
                item-text="text"
                item-value="value"
                label="Requiere pago para confirmar turno"
                dense
              ></v-select>
              <v-select
                class="mt-4"
                :items="cantDiasConfirmacionItems"
                v-model="cantDiasConfirmacion"
                item-text="text"
                item-value="value"
                label="Tiempo para confirmar turno"
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid || !os.length"
            @click.stop="guardarTope"
            >Guardar</v-btn
          >
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.flags {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}
</style>
<script>
import axios from "../../../axios-auth.js";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    totalRules: [
      (v) => !!v || "Dato obligatorio",
      (v) => v >= 0 || "El valor debe ser mayor o igual a 0",
    ],
    prof: "",
    profsBuscar: [],
    os: [],
    osBuscar: [],
    cantMaxTurnos: null,
    fechaDesde: null,
    fechaHasta: null,
    precioConsulta: null,
    esSena: false,
    muestraEnWeb: false,
    precioFinal: null,
    obligaPago: 0,
    requierePagoItems: [
      { text: "No requiere", value: 0 },
      { text: "Sólo para turnos tomdados en el portal", value: 1 },
      { text: "Sólo para los turnos dados internamente", value: 2 },
      { text: "Para todos los turnos", value: 3 },
    ],
    cantDiasConfirmacionItems: [
      { value: 0, text: "En el transcuro del día" },
      { value: 1, text: "Hasta mañana inclusive" },
    ],
    cantDiasConfirmacion: 0,
    idTipoTurno: 0,
    tiposTurnoItems: [],
  }),
  props: {
    visible: {
      type: Boolean,
    },
    esPrecio: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    resolveLabel() {
      return this.$store.state.usuario.institucion.esEmpresa
        ? "Sede"
        : "Obra Social";
    },
    resolveNoData() {
      return this.$store.state.usuario.institucion.esEmpresa &&
        (this.dni ||
          this.apellidos ||
          this.nombres ||
          this.prof ||
          this.profsBuscar)
        ? "No hay Sedes configuradas"
        : "No hay Obras Sociales configuradas";
    },
    textoTopePrecio() {
      return this.esPrecio ? "Precio" : "Tope";
    },
    itemsWithSelectAll() {
      return [
        { idObraSocial: "all", nombre: "Seleccionar todas" },
        ...this.osBuscar,
      ];
    },
  },
  methods: {
    onChange(value) {
      // si seleccionan "Seleccionar todas"
      const allIds = this.osBuscar.map((i) => i.idObraSocial);
      const hasAll = value.includes("all");

      if (hasAll) {
        // si ya estaban todas seleccionadas, deselecciona todo
        if (this.os.length === allIds.length + 1) {
          this.os = [];
        } else {
          // selecciona todo excepto el "all"
          this.os = [...allIds];
        }
      }
    },
    validarFecha(fecha) {
      if (fecha.toString().length > 10) return false;
      else return true;
    },
    guardarTope() {
      this.$swal({
        title: `Registrar ${this.textoTopePrecio}`,
        text: `¿Desea registrar el ${this.textoTopePrecio}?`,
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          if (!this.esPrecio) {
            let isValidDate = this.validarFecha(this.fechaDesde);
            if (!isValidDate) {
              this.showAlert({
                icon: "error",
                title: "La fecha desde no tiene un formato válido.",
                vm: this,
                timer: 2000,
              });
              return;
            }
            isValidDate = this.validarFecha(this.fechaHasta);
            if (!isValidDate) {
              this.showAlert({
                icon: "error",
                title: "La fecha hasta no tiene un formato válido.",
                vm: this,
                timer: 2000,
              });
              return;
            }
          }
          if (this.esPrecio && this.esSena && this.precioFinal && parseFloat(this.precioFinal) <= parseFloat(this.precioConsulta)) {
            this.showAlert({
              icon: "error",
              title: "El Precio Final debe ser mayor que el Precio Consulta (seña)",
              vm: this,
              timer: 3000,
            });
            return;
          }
          const params = this.esPrecio
            ? {
                idProfesional: this.prof,
                listaOs: this.os,
                precioConsulta: this.precioConsulta,
                esSena: this.esSena,
                muestraEnWeb: this.muestraEnWeb,
                obligaPago: this.obligaPago,
                cantDiasConfirmacion: this.cantDiasConfirmacion,
                idTipoTurno: this.idTipoTurno || 0,
                precioFinal: this.esSena ? this.precioFinal : null,
              }
            : {
                idProfesional: this.prof,
                listaOs: this.os,
                fechaDesde: this.fechaDesde,
                fechaHasta: this.fechaHasta,
                cantMax: this.cantMaxTurnos,
              };
          const endpoint = this.esPrecio
            ? "/ObraSocial/GuardarPrecio"
            : "/ObraSocial/GuardarTope";
          let self = this;

          if (!this.esPrecio && params.fechaDesde > params.fechaHasta) {
            self.showAlert({
              icon: "error",
              title: "La fecha desde no puede ser mayor que la fecha hasta",
              vm: this,
              timer: 2000,
            });
            return;
          }
          axios
            .post(endpoint, params)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title:
                  response.data === "error"
                    ? `${this.textoTopePrecio} registrado excepto para aquellas obras sociales que ya poseían un ${this.textoTopePrecio} previamente configurado para el profesional`
                    : `${this.textoTopePrecio} registrado`,
                vm: self,
                timer: response.data === "error" ? 4000 : 2000,
              });
              self.$emit("topeRegistrado");
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: `El ${this.textoTopePrecio} no pudo ser registrado`,
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },

    setearModels() {
      const profData = {
        usuario: this.$store.state.usuario.usuario,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Turnos/BuscarProfesionalesAsociados?", {
          params: {
            usuario: profData.usuario,
            idInstitucion: profData.idInstitucion,
          },
        })
        .then((response) => {
          self.profsBuscar = response.data.profesionales;
          self.prof = self.profsBuscar[0].idProfesional;
        });
      const osData = {
        nombre: null,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      axios
        .get("/ObraSocial/GetObraSocialNomDeInst?", {
          params: {
            nombre: null,
            idInstitucion: osData.idInstitucion,
            estado: 1,
          },
        })
        .then((response) => {
          self.osBuscar = response.data;
        })
        .catch((error) => {});

      // Cargar tipos de turno de la institución
      axios
        .get("/Profesional/GetTiposTurno", {
          params: {
            idInstitucion: profData.idInstitucion,
          },
        })
        .then((response) => {
          const tipos = response.data || [];
          self.tiposTurnoItems = [
            { idTipoTurno: 0, nombreTipoTurno: "TODOS" },
            ...tipos,
          ];
          self.idTipoTurno = 0;
        })
        .catch((error) => {});

      this.fechaDesde = this.parseDate(
        this.formatDate(this.toISOLocal(new Date()))
      );
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    toFixed() {
      if (isNaN(parseFloat(this.precioConsulta)))
        this.precioConsulta = parseFloat(0.0).toFixed(2);
      else this.precioConsulta = parseFloat(this.precioConsulta).toFixed(2);
    },
    toFixedFinal() {
      if (isNaN(parseFloat(this.precioFinal)))
        this.precioFinal = parseFloat(0.0).toFixed(2);
      else this.precioFinal = parseFloat(this.precioFinal).toFixed(2);
    },
    onlyNumberAndComma($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.cantMaxTurnos = "";
      this.fechaHasta = "";
      this.os = [];
      this.precioConsulta = null;
      this.esSena = false;
      this.muestraEnWeb = false;
      this.precioFinal = null;
      this.obligaPago = 0;
      this.cantDiasConfirmacion = 0;
      this.idTipoTurno = 0;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
  },
};
</script>
<style>
.dialog-topes {
  margin-top: 1rem;
}
.dialog-topes .os-col .v-input__slot {
  transform: translateY(-16px);
}
.tipo-turno {
  margin-top: 1.15rem;
}
</style>
